import React, { Component, Fragment } from 'react'
import { array, func, shape } from 'prop-types'
import { connect } from 'react-redux'
import { Tooltip, FactorTooltip } from 'src/components/shared'

import { MOBILE_VIEW_WIDTH_THREASHOLD } from 'src/util/PrioritizeUtil'
import './Participate.scss'

const Context = React.createContext()

class TableCell extends Component {
  state = { selected: false }
  onMouseEnter = () => {
    this.setState({ selected: !this.state.selected })
  }

  render() {
    const {
      children,
      selected,
      tooltip,
      disabled,
      question,
      ...other
    } = this.props
    const selectedClassName = selected ? 'selected' : ''
    const disablededClassName = disabled ? 'disabled' : ''
    const className = `participate-table_cell ${selectedClassName} ${disablededClassName}`

    return (
      <td {...other} className={className}>
        {tooltip ? (
          <Tooltip tooltip={tooltip}>{children}</Tooltip>
        ) : (
          <FactorTooltip factor={question}>{children}</FactorTooltip>
        )}
      </td>
    )
  }
}

const TableRow = ({ question, mobile = false }) => {
  const { title, responses, id } = question
  const getKey = (id) => `${mobile ? 'mobile' : ''}` + id

  const isMobile = window.innerWidth <= MOBILE_VIEW_WIDTH_THREASHOLD
  const colspan = isMobile ? '7' : '1'
  const className = `participate-table__${mobile ? 'mobile' : 'default'}`

  return (
    <tr className={className}>
      <Context.Consumer>
        {({ isSelected, onClick, isDisabled }) => (
          <>
            {!mobile && (
              <TableCell question={question} colSpan={colspan}>
                {title}
              </TableCell>
            )}
            {[...responses]
              .sort((a, b) => a.numeric_value - b.numeric_value)
              .map((responseObj) => (
                <TableCell
                  key={getKey(responseObj.id)}
                  disabled={isDisabled}
                  selected={isSelected(id, responseObj.id, responses)}
                  onClick={onClick(id, responseObj.id)}
                  tooltip={responseObj.description}
                >
                  {responseObj.title}
                </TableCell>
              ))}
          </>
        )}
      </Context.Consumer>
    </tr>
  )
}

class TabularView extends Component {
  onClick = (rowId, columnId) => () => {
    if (columnId === null) return
    const { onClick } = this.props
    if (onClick) onClick(rowId, columnId)
  }

  render() {
    const { collection, selectedNums, disabled = false } = this.props

    const isSelected = (rowId, questionId, responses) => {
      if (selectedNums) return selectedNums[rowId] === questionId
      if (responses)
        return responses.find((resp) => resp.vote && resp.vote.user_vote)
      return false
    }
    const onClick = disabled ? () => {} : this.onClick

    const contextValue = {
      isSelected: isSelected,
      onClick: onClick,
      isDisabled: disabled,
    }
    const defaultQuestions = []
    const questions =
      collection && collection.questions
        ? collection.questions
        : defaultQuestions

    return (
      <table className="participate-table">
        <tbody>
          <Context.Provider value={contextValue}>
            {questions.map((question, rowIdx) => (
              <Fragment key={rowIdx}>
                <TableRow question={question} />
                <TableRow mobile question={question} />
              </Fragment>
            ))}
          </Context.Provider>
        </tbody>
      </table>
    )
  }
}

TabularView.propTypes = {
  collection: shape({
    questions: array,
  }),
  onClick: func,
}

TabularView.defaultProps = {
  collection: {},
  onClick: null,
}

const mapStateToProps = (state) => {
  return {
    collection: state.prioritize.collection,
  }
}

export default connect(mapStateToProps, {})(TabularView)
